import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { to: '/', label: '首页' },
    { to: '/category/hot', label: '热门推荐' },
    { to: '/category/movie', label: '电影' },
    { to: '/category/tv', label: '电视剧' },
    { to: '/category/anime', label: '动漫' },
    { to: '/about', label: '关于我们' },
  ];

  const partnerLinks = [
    { label: '久久视频在线', href: '#' },
    { label: '小蓝视频', href: '#' },
    { label: '豆花视频', href: '#' },
    { label: '宅男视频流畅版', href: '#' },
  ];

  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="w-full px-4 md:px-6 py-12 md:py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center">
                  <i className="ri-play-circle-fill text-2xl text-primary-400"></i>
                </div>
                <span className="text-xl font-heading font-bold whitespace-nowrap">宅男视频</span>
              </div>
              <p className="text-sm text-foreground-400 leading-relaxed">
                接入久久视频、小蓝视频、豆花视频等稳定平台，提供不缓冲的流畅高清观看体验。免费影视全集每日更新，久用不卡顿。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold mb-4 text-background-50">
                <a href="#footer-quick-links" className="text-background-50 no-underline">快速导航</a>
              </h4>
              <ul className="space-y-2.5" id="footer-quick-links">
                {quickLinks.map((link) => (
                  <li key={link.to}>
                    <Link to={link.to} className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold mb-4 text-background-50">
                <a href="#footer-partners" className="text-background-50 no-underline">合作平台</a>
              </h4>
              <ul className="space-y-2.5" id="footer-partners">
                {partnerLinks.map((link) => (
                  <li key={link.label}>
                    <a href={link.href} className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer" rel="nofollow">
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold mb-4 text-background-50">
                <a href="#footer-contact" className="text-background-50 no-underline">联系我们</a>
              </h4>
              <ul className="space-y-2.5 text-sm text-foreground-400" id="footer-contact">
                <li className="flex items-start gap-2">
                  <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                    <i className="ri-mail-line text-xs"></i>
                  </div>
                  <span>contact@zhainanvideo.com</span>
                </li>
                <li className="flex items-start gap-2">
                  <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                    <i className="ri-customer-service-2-line text-xs"></i>
                  </div>
                  <span>在线客服 7×24小时</span>
                </li>
                <li className="flex items-start gap-2">
                  <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                    <i className="ri-shield-check-line text-xs"></i>
                  </div>
                  <span>安全绿色 · 无广告弹窗</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-foreground-800/30 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-500">
              &copy; {currentYear} 宅男视频 版权所有 | 视频不缓冲 · 流畅观看 · 免费高清 · 在线不卡顿
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">隐私政策</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">服务条款</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}